module.exports = __webpack_public_path__ + "img/eicon1.c7ec42ca.png";